import React from "react";
import { UserShiftLastUpdateBy } from "../../../types/Shift.types";
import { ApprovalTextDisplayWrapper, StyledApprovalText, StyledIcon } from "../styledComponents";
import { PayrollStatusReason, TimesheetSupportUserTypes, TimesheetTabs } from "../../../types/Payroll.types";
import { formatApproverName } from "../../../shiftUtils";

const approvedIconPath = `${
  import.meta.env.VITE_ASSET_BASE_URL
}/icons/Timesheets/approved-icon.svg`;

const getApprovedByText = (
  lastUpdateBy: UserShiftLastUpdateBy,
  activeTabIndex: TimesheetTabs | undefined,
  statusReason?: PayrollStatusReason | undefined,
  wasDisputed?: boolean,
) => {
  if (TimesheetSupportUserTypes.includes(lastUpdateBy.userType)) {
    const baseName = formatApproverName(lastUpdateBy.name, activeTabIndex);

    if (statusReason === PayrollStatusReason.SUPPORT_UNADJUSTED) {
      return `${baseName} (with Workplace edits)`;
    }
    if (statusReason === PayrollStatusReason.NO_ADJUSTMENTS) {
      return `${baseName} (with Crew Member timestamps)`;
    }
    if (statusReason === PayrollStatusReason.SUPPORT_ADJUSTED) {
      return `${baseName} (with Support adjustments)`;
    }

    if (wasDisputed) {
      return `${baseName} (Per Client Dispute)`;
    }

    return baseName;
  }
  return `Approved by ${lastUpdateBy.name}`;
};

export type ApprovalTextDisplayProps = {
  isAutoApproved: boolean;
  lastUpdatedBy: UserShiftLastUpdateBy;
  statusReason?: PayrollStatusReason;
  activeTabIndex?: TimesheetTabs | undefined;
  wasDisputed?: boolean;
};

export const ApprovalTextDisplay = ({
  isAutoApproved,
  lastUpdatedBy,
  statusReason,
  activeTabIndex,
  wasDisputed,
}: ApprovalTextDisplayProps) => (
  <ApprovalTextDisplayWrapper>
    <StyledIcon src={approvedIconPath} />
    <StyledApprovalText>
      {isAutoApproved ? "Auto-approved" : getApprovedByText(lastUpdatedBy, activeTabIndex, statusReason, wasDisputed)}
    </StyledApprovalText>
  </ApprovalTextDisplayWrapper>
);
